export const DATA_TABLE = [
    {
        label: "DC",
        key: "PLANT_PLANT",
    },
    {
        label: "Item Id",
        key: "MATERIAL_MATERIAL",
    },
    {
        label: "Vendor Id",
        key: "vendor_number",
    },
    {
        label: "Alert Type",
        key: "Alerts",
    },
    {
        label: "Standard Price",
        key: "standard_price",
    },
    {
        label: "Annual Revenue ($)",
        key: "annualRevenue",
    },
    {
        label: "AvgDemand Last 12W",
        key: "AvgDemand_Last12Months",
    },
    {
        label: "AvgDemand Last 8W",
        key: "AvgDemand_Last8Months",
    },
    {
        label: "AvgDemand Last 4W",
        key: "AvgDemand_Last4Months",
    },
    {
        label: "AvgForecast Last 4W",
        key: "AvgForecast_Last4Months",
    },
    {
        label: "Last 4W Accuracy",
        key: "Last4Month_Accuracy",
    },
    {
        label: "Last 4W BIAS",
        key: "Last4Month_BIAS",
    },
    {
        label: "Lag 2 W1",
        key: "Lag2_Foreast",
    },
    {
        label: "Lag 1 W1",
        key: "Lag1_Foreast",
    },
    {
        label: "CW Open SO",
        key: "CurrentMonthOpenSalesQty",
    },
    {
        label: "CW Forecast",
        key: "forecastMonth0",
    },
    {
        label: "Adjusted CW Forecast",
        key: "AdjustedForecast0",
    },
    {
        label: "NW Forecast",
        key: "forecastMonth1",
    },
    {
        label: "Adjusted NW Forecast",
        key: "AdjustedForecast1",
    },
    {
        label: "Comments",
        key: "Comments",
    },
    {
        label: "Reviewed?",
        key: "isReviewed",
    },
];

export const INACTIVE_INV_TABLE = [
    {
        label: "Item Id",
        key: "material",
    },
    {
        label: "DC",
        key: "plant",
    },
    {
        label: "Category",
        key: "category",
    },
    {
        label: "District",
        key: "cluster",
    },
    {
        label: "Vendor Id",
        key: "Vendor_Code",
    },
    {
        label: "Segment",
        key: "segment",
    },
    {
        label: "OnHand ($)",
        key: "onHand$",
    },
    {
        label: "OnHand (Qty)",
        key: "onHand",
    },
    {
        label: "Devalued (Qty)",
        key: "Qty_DevaluedBy",
    },
    {
        label: "Devalued ($)",
        key: "Onhand$Value_DevaluedBy"
    },
    {
        label: "Inventory Age",
        key: "InventoryAgeBuckets"
    },
    {
        label: "Last Received Date",
        key: "Lst_Rc_Dt",
    },
    {
        label: "Potential Actions",
        key: "RecommendedAction_Aging",
    }
];

export const OVERSTOCK_INV_TABLE = [
    {
        label: "Item Id",
        key: "material",
    },
    {
        label: "District",
        key: "Plant_Code",
    },
    {
        label: "DC",
        key: "plant",
    },
    {
        label: "Category",
        key: "category",
    },
    {
        label: "Segment",
        key: "segment",
    },
    {
        label: "Vendor Id",
        key: "Vendor_Code",
    },
    {
        label: "OnHand ($)",
        key: "Onhand$Value",
    },
    {
        label: "OnHand (Qty)",
        key: "onhand",
    },
    {
        label: "Open PO",
        key: "open_eros",
    },
    {
        label: "NM forecast + Open SO",
        key: "Total_Dmd_Within_LT_Custom"
    },
    {
        label: "Safety Stock (Qty)",
        key: "effective_ss"
    },
    {
        label: "Cycle Stock (Qty)",
        key: "Adjusted_ORQ"
    },
    {
        label: "Lead Time (Weeks)",
        key: "Rep_LT",
    },
    {
        label: "Inv at End of LT (Qty)",
        key: "InvAtEndOfLT",
    },
    {
        label: "Overstock at End of LT (Qty)",
        key: "InventoryThreshold",
    },
    {
        label: "PO Number",
        key: "ponumber",
    },
    {
        label: "PO Status",
        key: "openClosePOFlag",
    },
    {
        label: "PO Qty",
        key: "poqty"
    },
    {
        label: "PO Value",
        key: "povalue"
    },
    {
        label: "PO Type",
        key: "poTypeFlag"
    }
];

export const STOCKOUT_INV_TABLE = [
    {
        label: "Item Id",
        key: "material",
    },
    {
        label: "District",
        key: "cluster",
    },
    {
        label: "DC",
        key: "plant",
    },
    {
        label: "Category",
        key: "category",
    },
    {
        label: "Segment",
        key: "segment",
    },
    {
        label: "Vendor Id",
        key: "Vendor_Code",
    },
    {
        label: "OnHand ($)",
        key: "Onhand$Value",
    },
    {
        label: "OnHand (Qty)",
        key: "onHand",
    },
    {
        label: "Open PO (Qty)",
        key: "open_eros",
    },
    {
        label: "NM forecast + Open SO",
        key: "Total_Dmd_Within_LT_Custom",
    },
    {
        label: "Inv at End of NM (QTY)",
        key: "InvAtEndOfLT2",
    },
    {
        label: "Safety Stock (QTY)",
        key: "Effective_SS",
    },
    {
        label: "Cycle Stock",
        key: "Adjusted_ORQ",
    },
    {
        label: "Potential Actions",
        key: "RecommendedAction_HighStockout",
    },
];

export const PO_INV_TABLE = [
    {
        label: "Item Id",
        key: "material",
    },
    {
        label: "District",
        key: "plant",
    },
    {
        label: "DC",
        key: "category",
    },
    {
        label: "Segment",
        key: "segment",
    },
    {
        label: "Vendor Id",
        key: "Vendor_Code",
    },
    {
        label: "OnHand ($)",
        key: "Onhand$Value",
    },
    {
        label: "OnHand (Qty)",
        key: "onhand",
    },
    {
        label: "Open PO (Qty)",
        key: "open_eros",
    },
    {
        label: "NM forecast + Open SO",
        key: "Total_Dmd_Within_LT_Custom",
    },
    {
        label: "Safety Stock (Qty)",
        key: "effective_ss",
    },
    {
        label: "Cycle Stock (Qty)",
        key: "Adjusted_ORQ",
    },
    {
        label: "Lead Time (Weeks)",
        key: "Rep_LT",
    },
    {
        label: "Inv at End of LT (Qty)",
        key: "InvAtEndOfLT",
    },
    {
        label: "Overstock at End of LT (Qty)",
        key: "PotentialOverStock",
    },
    {
        label: "PO Number",
        key: "ponumber",
    },
    {
        label: "PO Status",
        key: "openClosePOFlag",
    },
    {
        label: "PO Qty",
        key: "poqty",
    },
    {
        label: "PO Value",
        key: "povalue",
    },
    {
        label: "PO Type",
        key: "poTypeFlag",
    },
];